import { Edit } from '@workwave-tidal/core/icons'

import { preview } from '@/components/form/preview'

import { useFormatLanguage } from '../hooks/useFormatLanguage'
import { useLanguageAndFormatsData } from '../hooks/useLanguageAndFormatsData'
import { useTexts } from './hooks/useTexts'

import { getDateFormats, timeFormats } from '../../formats'

type Props = {
  onEdit: () => void
}

export function LanguageAndFormatsView(props: Props) {
  const { onEdit } = props

  const texts = useTexts()

  const [languageAndPreferences] = useLanguageAndFormatsData()
  const formatLanguage = useFormatLanguage()
  const dateFormats = getDateFormats()

  return (
    <preview.Root
      testId="language-and-formats-view"
      applyPendingFitMapOnMount={false}
      rightBorder={false}
      header={
        <preview.Header
          title={texts.headerTitle}
          subtitle={texts.headerDescription}
          testId="language-and-formats-view-header"
        >
          <preview.ActionBar>
            <preview.ActionBarItem
              icon={<Edit />}
              onClick={onEdit}
              label={texts.edit}
              disableWhenReadOnly={false}
              tooltip={texts.edit}
              testId="language-and-formats__edit"
              data-trackid="language-and-formats__edit"
            />
          </preview.ActionBar>
        </preview.Header>
      }
    >
      <preview.Field testId="language-and-formats-language" label={texts.language}>
        {formatLanguage(languageAndPreferences.language)}
      </preview.Field>

      <preview.Field testId="language-and-formats-dateFormat" label={texts.dateFormat}>
        {dateFormats[languageAndPreferences.dateFormat]}
      </preview.Field>

      <preview.Field testId="language-and-formats-timeFormat" label={texts.timeFormat}>
        {timeFormats[languageAndPreferences.timeFormat]}
      </preview.Field>

      <preview.Field testId="language-and-formats-distanceFormat" label={texts.distanceFormat}>
        {texts.distanceFormatValue(languageAndPreferences.distanceFormat)}
      </preview.Field>

      <preview.Field testId="language-and-formats-currency" label={texts.currency}>
        {languageAndPreferences.currency}
      </preview.Field>
    </preview.Root>
  )
}
